import axios from 'axios'
import jwt from '@/helpers/jwtHelper'

function configPages(config) {
  config.headers['Authorization'] = jwt.token
  return config
}

function handleError(err) {
  return Promise.reject(err)
}

export const pages = axios.create({ baseURL: `${process.env.VUE_APP_API}` })
pages.interceptors.request.use(configPages, handleError)
